import { render, staticRenderFns } from "./wheelPlant.vue?vue&type=template&id=81c4f55c&"
import script from "./wheelPlant.vue?vue&type=script&lang=js&"
export * from "./wheelPlant.vue?vue&type=script&lang=js&"
import style0 from "./wheelPlant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports